import { useLDClient } from 'launchdarkly-react-client-sdk'

import Cookies from 'js-cookie'
import useSWR, { SWRConfiguration, SWRResponse, unstable_serialize } from 'swr'

import { ErrorResponse, UserResponse } from '@infura/packages.api'
import { FEATURE_PREVIEW_COOKIE } from '@infura/packages.common/constants'

import { useApi } from 'lib/api/api'

export const key = ['getMe'] as const
export const dataKey = unstable_serialize(key)
export const errorKey = '$err$' + dataKey
const TESTING = process.env.ENVIRONMENT === 'test' && !!process.env.CI

const defaultConfig: SWRConfiguration = { revalidateOnFocus: false, revalidateOnMount: true }

// This 'useUser' thing is a hook that is used to get the user data from the API.
// It seems like it calls the getMe API method. And there are over 100 references to it in the codebase.
//
// Could this be a candidate for creating some piece of global state?

export default function useUser(config?: SWRConfiguration) {
  const ldClient = useLDClient()
  const feature_preview = Cookies.get(FEATURE_PREVIEW_COOKIE)
  const { data, error, ...swr } = useApi(key, { ...defaultConfig, ...config }) as SWRResponse<UserResponse>
  const { data: ldUserIdentified } = useSWR(
    ['ldClient', ldClient, data?.data],
    // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
    async ([, ldClient, { created, email, id }]) => {
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      await ldClient.waitUntilReady()
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      await ldClient.identify({
        created_at: new Date(created * 1000).toISOString(),
        email,
        ...(feature_preview && { feature_preview }),
        key: id,
        kind: 'user'
      })
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      const u = ldClient.getContext()
      return (!!u && !u.anonymous) || TESTING
    }
  )

  const user = data?.data
  const isAuthenticated = !!user && !error

  return {
    error: error as ErrorResponse,
    isAuthenticated,
    isAuthorized:
      // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
      isAuthenticated && user?.verified && (data.data.mfa?.enabled ? data?.session?.mfa_verified > 0 : true),
    ldUserIdentified: ldUserIdentified === true,
    loading: !data && !error,
    session: data?.session,
    user: data?.data,
    ...swr
  }
}
